import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { EnumHintKey } from '@data-layer/enums/common';
import { enumShippingRole } from '@data-layer/enums/user';

@Component({
  selector: 'company-shipping-role',
  templateUrl: './company-shipping-role.component.html',
  styleUrls: ['./company-shipping-role.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyShippingRoleComponent {
  @Input() public formGroup: UntypedFormGroup;
  @Input() public isShowDescription: boolean = false;
  @Input() public isOldStyleTheme: boolean = false;

  public enumHintKey: typeof EnumHintKey = EnumHintKey;
  public enumShippingRole: typeof enumShippingRole = enumShippingRole;

  constructor() {}
}
